require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-jennersdorf-heiligenkreuz-im-lafnitztal.json") })
        }
      }, "path---betreuungseinrichtungen-jennersdorf-heiligenkreuz-im-lafnitztal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-jennersdorf-heiligenkreuz-im-lafnitztal!./.cache/json/betreuungseinrichtungen-jennersdorf-heiligenkreuz-im-lafnitztal.json
// module id = 912
// module chunks = 231608221292675